import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { setHostname } from "./hostname";
import { setCredential, setHeaders } from "./credential";

export const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let baseUrl = setHostname();
  const credentials = setCredential();
  const urlEnd = typeof args === "string" ? args : args.url;

  if (urlEnd.startsWith("/games")) {
    baseUrl = baseUrl.replace("/v1", "/v2");
  }

  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    credentials,
    prepareHeaders: setHeaders,
  });
  return rawBaseQuery(args, api, extraOptions);
};
